// extracted by mini-css-extract-plugin
export default {"narrow-page-wrapper":"NarrowPageWrapper_narrow-page-wrapper__5-4ij","narrowPageWrapper":"NarrowPageWrapper_narrow-page-wrapper__5-4ij"};